import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Brand } from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, reset_base: window.location.origin });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F4F0EA] flex flex-col">
      <header className="max-w-7xl mx-auto w-full px-6 py-8"><Brand /></header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="text-[10px] tracking-[0.4em] text-[#C5A059] uppercase mb-4">Espace propriétaire</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-light mb-6">Mot de passe oublié.</h1>

          {done ? (
            <div className="space-y-6" data-testid="forgot-success">
              <p className="text-sm text-[#A39E93]">
                Si un compte existe pour <strong className="text-[#F4F0EA]">{email}</strong>, un email contenant un lien de réinitialisation vient d&apos;être envoyé. Le lien est valable 1 heure.
              </p>
              <Link to="/login" className="btn-primary w-full justify-center" data-testid="forgot-back-login">Retour à la connexion</Link>
            </div>
          ) : (
            <>
              <p className="text-sm text-[#A39E93] mb-10">Saisissez l&apos;adresse email de votre compte. Nous vous enverrons un lien pour définir un nouveau mot de passe.</p>
              <form onSubmit={submit} className="space-y-6" data-testid="forgot-form">
                <div>
                  <Label htmlFor="email" className="text-xs uppercase tracking-[0.2em] text-[#A39E93]">Email</Label>
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-[#141311] border-[#2C2A26] h-12" required data-testid="forgot-email" />
                </div>
                {error && <div className="text-sm text-[#E08D8D] border border-[#8C3131]/40 bg-[#8C3131]/10 p-3" data-testid="forgot-error">{error}</div>}
                <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="forgot-submit">
                  {loading ? "Envoi…" : (<><Mail className="w-4 h-4" strokeWidth={1.5} /> Envoyer le lien</>)}
                </button>
              </form>
              <Link to="/login" className="block text-center mt-8 text-xs uppercase tracking-[0.25em] text-[#A39E93] hover:text-[#C5A059]" data-testid="forgot-back">← Retour à la connexion</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
